export function cmToIn(cm: number): number { return +(cm / 2.54).toFixed(1); }
export function inToCm(inches: number): number { return +(inches * 2.54).toFixed(1); }
export function kgToLbs(kg: number): number { return +(kg * 2.205).toFixed(1); }
export function lbsToKg(lbs: number): number { return +(lbs / 2.205).toFixed(1); }
export function ftInToCm(ft: number, inch: number): number { return +((ft * 30.48) + (inch * 2.54)).toFixed(1); }

export function isImperial(locale: string): boolean {
  return ["US", "UK", "AU"].includes(locale);
}

/**
 * Human-readable label for a unit token. Used to append a system label to
 * primary CTAs ("Find My Best Fit (Metric)") so the user knows whether their
 * values will be interpreted as cm/kg or in/lbs before they submit.
 */
export function getUnitLabel(unit: string | undefined | null): string {
  if (unit === "in" || unit === "inches" || unit === "lbs") return "Imperial";
  if (unit === "cm" || unit === "kg") return "Metric";
  if (unit === "mm") return "mm";
  return "";
}
